<template>
	<div class="grid-flex-container">
		<v-container fluid class="py-6">
			<v-row class="d-flex">
				<div style="flex-grow: 1">
					<v-text-field
						v-if="canView"
						v-model="search"
						class="py-0 my-0 mb-2 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<v-btn v-if="canAdd" color="primary" @click="onAdd()">
					<v-icon> mdi-plus</v-icon>
					&nbsp;&nbsp;Add
				</v-btn>
			</v-row>
		</v-container>
		<div class="generic-grid-container">
			<v-data-table
				v-if="canView"
				:headers="headers"
				:items="items"
				:disable-pagination="true"
				:search.sync="search"
				item-key="Id"
				sort-by="Order"
				fixed-header
				dense
				:loading="loading"
				hide-default-footer
				loading-text="Loading..."
			>
				<template v-slot:body="props">
					<draggable
						@change="reorder(props.items)"
						:list="props.items"
						tag="tbody"
					>
						<tr v-for="(item, index) in props.items" :key="index">
							<td>
								<v-icon small color="primary"
									>mdi-reorder-horizontal</v-icon
								>
							</td>
							<td>{{ item.Label }}</td>
							<td>
								<v-chip-group v-if="item.GridViewFields">
									<v-chip
										v-for="(
											field, index
										) in item.GridViewFields"
										v-bind:key="index"
										:ripple="false"
										small
									>
										{{ field.Label }}
									</v-chip>
								</v-chip-group>
							</td>
							<td>
								<v-icon color="primary" v-if="item.PrimaryKey"
									>mdi-key-variant</v-icon
								>
							</td>
							<td>
								<v-icon color="primary" v-if="item.Required"
									>mdi-check-circle</v-icon
								>
								<v-icon color="error" v-else
									>mdi-close-circle</v-icon
								>
							</td>
							<td>
								<v-icon
									color="primary"
									v-if="item.CanIgnoreErrors"
									>mdi-check-circle</v-icon
								>
								<v-icon color="error" v-else
									>mdi-close-circle</v-icon
								>
							</td>
							<td>
								<v-icon color="primary" v-if="item.ForceChoice"
									>mdi-check-circle</v-icon
								>
								<v-icon color="error" v-else
									>mdi-close-circle</v-icon
								>
							</td>
							<td>
								<v-icon
									color="primary"
									v-if="item.AllowUserToRetainValue"
									>mdi-pin</v-icon
								>
								<v-icon color="error" v-else
									>mdi-pin-off</v-icon
								>
							</td>
							<td>
								<v-icon
									color="primary"
									v-if="item.HiddenBehaviour != 0"
									>mdi-check-circle</v-icon
								>
								<v-icon color="error" v-else
									>mdi-close-circle</v-icon
								>
							</td>
							<td>
								<v-icon color="primary" v-if="item.IsVisible"
									>mdi-check-circle</v-icon
								>
								<v-icon color="error" v-else
									>mdi-close-circle</v-icon
								>
							</td>
							<td>
								<v-icon color="primary" v-if="item.Readonly"
									>mdi-check-circle</v-icon
								>
								<v-icon color="error" v-else
									>mdi-close-circle</v-icon
								>
							</td>
							<td>
								<v-icon color="primary" v-if="item.Uppercase"
									>mdi-check-circle</v-icon
								>
								<v-icon color="error" v-else
									>mdi-close-circle</v-icon
								>
							</td>
							<td class="fixed-col">
								<v-btn
									v-if="canEdit"
									fab
									small
									icon
									elevation="1"
									class="action-btn"
									@click.stop="onEdit(item)"
								>
									<v-icon color="primary" small
										>mdi-pencil</v-icon
									>
								</v-btn>
								<v-btn
									v-if="canDelete"
									fab
									small
									icon
									elevation="1"
									class="action-btn"
									@click.stop="onDelete(item)"
								>
									<v-icon color="error" small
										>mdi-delete</v-icon
									>
								</v-btn>
							</td>
						</tr>
					</draggable>
				</template>
			</v-data-table>
		</div>

		<form-field-modal
			v-if="showFormFieldModal"
			:showDialog="showFormFieldModal"
			@close="onCloseFormFieldsModal"
		/>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { FormFieldsGetters } from '../../../../store/getters';
import { FormFieldsActions } from '../../../../store/actions';
import FormFieldModal from './FormFieldsModal.vue';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import { Permissions } from '../../../../enums/permissionsEnum';
import permissionsMixin from '../../../../mixins/permissionsMixin';
import Draggable from 'vuedraggable';
export default {
	name: 'InventoryFormFormFields',
	components: { FormFieldModal, Draggable },
	mixins: [permissionsMixin],
	computed: {
		...mapGetters({
			loading: [FormFieldsGetters.GRID_LOADING],
			items: [FormFieldsGetters.FORM_FIELDS],
		}),
		canView() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Fields.View,
			]);
		},
		canAdd() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Fields.Add,
			]);
		},
		canEdit() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Fields.Edit,
			]);
		},
		canDelete() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Fields.Delete,
			]);
		},
		inventoryFormId() {
			if (!this.$route.params) return -1;
			if (!this.$route.params.id) return -1;
			return this.$route.params.id;
		},
		reorderData() {
			return JSON.parse(
				JSON.stringify(
					this.items
						.filter((x) => x.HiddenBehaviour === 0)
						.sort((a, b) => a.Order - b.Order)
				)
			);
		},
	},
	data() {
		return {
			reordered: [],
			showFormFieldModal: false,
			showReorderModal: false,
			search: '',
			headers: [
				{ text: '', sortable: false, value: 'Draggable', width: 10 },
				{ text: 'Label', sortable: false, value: 'Label' },
				{ text: 'Fields', sortable: false, value: 'GridViewFields' },
				{
					text: 'Primary',
					sortable: false,
					value: 'PrimaryKey',
					width: 5,
				},
				{ text: 'Required', sortable: false, value: 'Required' },
				{
					text: 'Can Ignore Errors',
					sortable: false,
					value: 'CanIgnoreErrors',
				},
				{ text: 'Force Choice', sortable: false, value: 'ForceChoice' },

				{
					text: 'Allow user to retain value',
					sortable: false,
					value: 'AllowUserToRetainValue',
				},
				{
					text: 'Hidden',
					sortable: false,
					value: 'Hidden',
				},
				{
					text: 'Visible on load',
					sortable: false,
					value: 'IsVisible',
				},
				{
					text: 'Readonly',
					sortable: false,
					value: 'Readonly',
				},
				{
					text: 'Uppercase',
					sortable: false,
					value: 'Uppercase',
				},

				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
		};
	},
	mounted() {
		this.$store.dispatch(FormFieldsActions.LOAD, this.inventoryFormId);
	},
	destroyed() {
		this.$store.dispatch(FormFieldsActions.CLEAR);
	},
	methods: {
		reorder(props) {
			this.reordered = props;
			this.reordered.forEach((element) => {
				element.Order = this.reordered.indexOf(element) + 1;
			});
			this.$store.dispatch(FormFieldsActions.REORDER_FIELDS, {
				id: this.inventoryFormId,
				data: this.reordered,
			});
		},
		onAdd() {
			this.$store.dispatch(FormFieldsActions.SET_SELECTED_FORM_FIELD, {
				Order: this.items.length + 1,
				InventoryFormId: this.inventoryFormId,
				GridViewFieldIds: [],
				CanIgnoreErrors: false,
				Required: false,
				ForceChoice: false,
				AllowUserToRetainValue: false,
				Regex: null,
				InputMask: null,
				Label: null,
				Separator: null,
				FormFieldRules: [],
			});
			this.showFormFieldModal = true;
		},
		onEdit(item) {
			this.$store.dispatch(
				FormFieldsActions.SET_SELECTED_FORM_FIELD,
				item
			);
			this.showFormFieldModal = true;
		},
		onDelete(item) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this form field?',
			}).then((isDelete) => {
				if (!isDelete) return;
				this.$store.dispatch(FormFieldsActions.DELETE, item);
			});
		},
		onShowReorderModal() {
			this.showReorderModal = true;
		},
		onSubmitReorderModal() {
			this.$store.dispatch(FormFieldsActions.LOAD, this.inventoryFormId);
			this.showReorderModal = false;
		},
		onShowReorderModalClose() {
			this.showReorderModal = false;
		},
		onCloseFormFieldsModal() {
			this.showFormFieldModal = false;
			this.$store.dispatch(
				FormFieldsActions.SET_SELECTED_FORM_FIELD,
				null
			);
		},
	},
};
</script>
